<style src="./../assets/style.css"></style>
<template>
    <div>
        <v-container>
            <div class="page_not_found">
                <h3>404</h3>
                <p>OOPS!</p>
                <p>Page not found!</p>
            </div>
        </v-container>
    </div>
</template>

<script>
    import appCallToAction from './CallToAction'
    import GlobalService from './../services/Global'
    export default {
        data () {
            return {
            }
        },
        components: {
        },
        created () {
            GlobalService.goToTop()
        },
        methods: {
        }
    }
</script>
